/* eslint-disable */
import { chain, sortBy } from 'underscore';
import { IReturnProductTour, IReturnProductHotelOffer } from '@ve/pages/hotel/types';
// @ts-ignore: Unreachable code error
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import { selectIdentitiesForOperator, selectAdditionalTravelataTourIds } from '@/js/common/components/hotel/tourProductUtils';

export default (tourProducts: IReturnProductTour[], directFlightFilter: boolean | undefined, hotelOfferProducts: IReturnProductHotelOffer[] = []): { url: string } => {
    if (!tourProducts.length) return { url: '' };
    const paramsForRouter = {
        sid: searchSessionService.getSearchId(),
        hsid: searchSessionService.getHotelSearchId(),
    };

    const isExclusive = tourProducts[0]?.isExclusive;
    const hotelId = tourProducts[0].hotel;
    if (isExclusive) {
        // @ts-ignore: Unreachable code error
        paramsForRouter.isExclusive = true;
    }
    if (directFlightFilter) {
        // @ts-ignore: Unreachable code error
        paramsForRouter.directFlight = true;
    }
    const tourIdentities = chain(tourProducts)
        .groupBy((tourProduct) => tourProduct.operator.id)
        .pairs()
        .map(([operatorId, operatorTours]) => {
            const sorted = sortBy(operatorTours, (tour) => tour.price);
            return selectIdentitiesForOperator(sorted, Number(operatorId)).map((t) => t.id);
        })
        .flatten()
        .value();

    const toursInfo = tourProducts.map((t) => ({
        id: t.id,
        operatorId: t.operator.id,
        price: t.price,
        transferType: t.transferType,
        block: t.block,
        hotelAvailable: t.hotelAvailable,
    }));
    const additionalTravelataIds = selectAdditionalTravelataTourIds(toursInfo, tourIdentities);
    tourIdentities.push(...additionalTravelataIds);

    const cheapestHotelOffer = hotelOfferProducts.length
        ? hotelOfferProducts.reduce((min, offer) => (offer.price < min.price ? offer : min))
        : null;
    const hotelOfferIdentities = cheapestHotelOffer ? [cheapestHotelOffer.id] : [];

    if (tourIdentities.includes(tourProducts[0].id) && tourProducts[0].price)
        Object.assign(paramsForRouter, {
            hotelMinPriceIdentity: tourProducts[0].id,
            hotelMinPrice: tourProducts[0].price,
            hotelMinPriceOilTax: 0,
        })

    return {
        url: (`/hotel/${hotelId}/tourPage?${$.param({ identities: tourIdentities, hotelOfferIdentities })}#?${$.param(paramsForRouter)}`),
    };
};